// Global configuration values
export const config = {
  BASE_URL: 'https://bagusphere.com/rentapi/api',
  // Add other global configuration values here as needed
};

// For convenience, also export commonly used values directly
export const { BASE_URL } = config; 